import { Breakpoint, Color, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { ContentWrapperProps } from './centeredContentSlideWrapper.types';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Image = styled.img`
  height: 100%;
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  ${({ $fullWidth }: ContentWrapperProps): string | false => !$fullWidth && 'max-width: 880px'};
  flex-shrink: 0;
  background-color: ${Color.Gray100};
  padding: 32px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 32px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid ${Color.Brand300};
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeaderTypography = styled(Typography)`
  color: ${Color.Gray600};
`;
